import filterByLocation from './filterByLocation'
import filterByPatient from './filterByPatient'
import filterByPrice from './filterByPrice'
import filterByProfessional from './filterByProfessional'
import filterBySpecialities from './filterBySpecialities'
import filterByCovenantType from './filterByCovenantType'
import filterBySchedules from './filterBySchedules'

export default (searchedBy, filters, agenda, covenant, level, user) => {
  filterByLocation(searchedBy, filters, agenda)
  filterByPrice(searchedBy, filters, agenda)
  filterBySchedules(searchedBy, filters, agenda, level)
  filterByProfessional(searchedBy, filters, agenda)
  filterBySpecialities(searchedBy, filters, agenda)
  filterByCovenantType(searchedBy, filters, agenda, covenant)
  filterByPatient(searchedBy, filters, agenda, user)
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/index.js